// @ts-nocheck
import { BlockParsedBaseProps } from "@store/Components/Toolkit/Block/Block";
import { BlockVariantBaseProps } from "@store/Components/Toolkit/Block/variant/base";
import { blockVariantOptions } from "@store/Components/Toolkit/Block/variant/config";
import { getDataOption } from "@store/Framework/Common/Utilities/dataOptions";
import { css } from "styled-components";

export const getVariantCss = (property: keyof BlockVariantBaseProps) => {
    return ({ variant, variantProps }: BlockParsedBaseProps) => {
        if (variant && variantProps) {
            const variantType = getDataOption(blockVariantOptions, variant)?.type;

            if (variantType) {
                return css`
                    ${variantType.staticProps[property]}
                    ${(variantProps as any)[variant]?.[property]}
                `;
            }
        }

        return null;
    };
};
